module.exports = __webpack_public_path__ + "img/DSC_2748-xs.f17d3d84.png";